module.exports = __webpack_public_path__ + "img/background-image-opacity.a409477d.png";